import type { CSSProperties } from 'react';

export const listHeaderStyle: CSSProperties = {
  width: '100%',
  background: '#fff',
  flexDirection: 'row',
};

const shimmerStyle: CSSProperties = {
  background: 'linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%)',
  backgroundSize: '200% 100%',
  animation: 'sk-wave 1.5s infinite',
  borderRadius: 4,
};

export const SHIMMER_KEYFRAMES = `
  @keyframes sk-wave {
    0%   { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;

export const titleRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 12,
};

export const titleIconShimmerStyle: CSSProperties = {
  ...shimmerStyle,
  width: 24,
  height: 24,
  borderRadius: 4,
};

export const titleLineShimmerStyle: CSSProperties = {
  ...shimmerStyle,
  width: '40%',
  height: 20,
};

export const brandLogosRowStyle: CSSProperties = {
  display: 'flex',
  gap: '2%',
  marginBottom: 8,
};

export const brandLogosRowStylePlain: CSSProperties = {
  display: 'flex',
  gap: '2%',
};

export const brandCircleShimmerStyle: CSSProperties = {
  ...shimmerStyle,
  width: 66,
  height: 66,
  borderRadius: '50%',
  flexShrink: 0,
};

export const chipRowStyle: CSSProperties = {
  display: 'flex',
  gap: 8,
  flexWrap: 'wrap',
};

export const chipShimmerStyle: CSSProperties = {
  ...shimmerStyle,
  width: '10%',
  height: 33,
  borderRadius: 18,
};
